import React, { lazy } from "react";
import styled from "styled-components";
import logo1 from ".//vianaar_homes_logo.jpeg"
import logo2 from ".//vad.jpeg"
import logo3 from ".//DP.jpeg"
import logo4 from ".//VW.png"


import Slider from "react-slick";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

const Card = lazy(() => import("../../components/Card/index"));

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 5rem 0;
`;

const Title = styled.h1`
  color: #0a0b10;
  display: inline-block;
  font-size: calc(1rem + 1.5vw);
  margin-top: 1.5rem;
  position: relative;
  &::before {
    content: "";
    height: 1px;
    width: 50%;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0.5rem);
    /* or 100px */
    border-bottom: 2px solid var(--purple);
  }
`;

const Carousal = styled.div`
  width: 50vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only Screen and (max-width: 40em) {
    width: 90vw;
    .slick-slider .slick-arrow {
      display: none;
    }
  }
  .slick-slider .slick-arrow:before {
    color: #0a0b10;
    font-size: 1.5rem;
    @media only Screen and (max-width: 40em) {
      display: none;
    }
  }
  .slick-slider .slick-dots button:before {
    color: #0a0b10;
    font-size: 1.5rem;
  }
  .slick-slide.slick-active {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 0;
    margin-bottom: 3rem;
  }
`;


const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,

    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Section id="Testimonials">
      {<Title>Few  Clients we've worked with</Title>}
      {<Carousal>
        {<Slider {...settings}>
          <Card
            text="Vianaar is Goa's leading real estate development company, building beautiful holiday homes in the serene villages of North Goa."
            name="Vianaar"
            companyImage={logo1}
          />

          <Card
            text="Experience Abu Dhabi is a travel and tourism initiative that offers a variety of experiences in the city, including cultural landmarks, adventure, relaxation, and exploring regions"
            name="Experience Abu Dhabi"
            companyImage={logo2}
            
          />

          <Card
            text="DP World is an Emirati multinational logistics company based in Dubai, United Arab Emirates, specialising in cargo logistics, port terminal operations, maritime services and free trade zones"
            name="DP World"
            companyImage={logo3}
          />

          <Card
            text="Volkswagen is a German automobile manufacturer"
            name="Volkswagen MENA"
            companyImage={logo4}
                      />
        </Slider> }
       </Carousal> }
    </Section>
  );
};

export default Testimonials;
